<!-- src/App.vue -->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: 'Helvetica Neue', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  background-color: #ffffff;
  color: #333;
}

#app {
  height: 100%; /* ✅ 让 router-view 填满视口，支持 flex 子页面布局 */
}

/* 全站滚动条：默认接近隐藏，悬停到可滚动区域时显示品牌深蓝（Firefox + WebKit） */
* {
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}
*:hover {
  scrollbar-color: #2e3968 rgba(46, 57, 104, 0.1);
}
*::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
*::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 4px;
}
*:hover::-webkit-scrollbar-track {
  background: rgba(46, 57, 104, 0.06);
}
*::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 4px;
}
*:hover::-webkit-scrollbar-thumb {
  background: #2e3968;
}
*:hover::-webkit-scrollbar-thumb:hover {
  background: #1e2a52;
}

/* ✅ 所有页面通用的 loading 过渡效果 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>
